export const mailTypes = [
    { label: "Follow up basic info", key: 4 },
    { label: "Follow up personality", key: 1 },
    { label: "Follow up quiz", key: 2 },
    { label: "Follow Up Behaviour & Quiz", key:13},
    { label: 'Reject', key: 3 },
    { label: "Update under review", key: 5 },
    { label: "Update delay", key: 6 },
    { label: "Custom mail", key: 0 },
    { label: 'Share Access Link', key: 7 },
    { label: 'Exclusion Salary&Experience', key: 8 },
    { label: 'Exclusion Salary Only', key: 9 },
    { label: 'Exclusion Experience Only', key: 10 },
    { label: 'Exclusion Industry Only', key: 11 },
    { label: 'Re-Inclusion', key: 12 },
];